import { memo, useMemo, useRef } from 'react';
import { Menu } from '@wg/wows-react-uikit';

import settings from '~/settings';
import { SEASON_TYPES } from '~/constants';
import { getLocalizationSafe, t } from '~/helpers/localization';

import styles from './LadderSeasonsDropdown.scss';

interface SeasonMenuItem {
  value: number;
  content: React.ReactNode;
}

interface LadderSeasonsDropdownProps {
  selectedSeasonId: number;
  selectedSeasonType?: SEASON_TYPES;
  dropdownPosition?: 'top' | 'bottom' | 'left';
  onSeasonChange: (season: number) => void;
}

const LadderSeasonsDropdown = (props: LadderSeasonsDropdownProps) => {
  const { selectedSeasonId, selectedSeasonType, dropdownPosition, onSeasonChange } = props;

  const lastSeasonIdRef = useRef<number | null>(null);

  const seasonsList = useMemo(() => {
    const ladderSettings = settings.ladder;
    const seasons = (ladderSettings && ladderSettings.seasons) || {};

    const list: SeasonMenuItem[] = [];

    for (const key of Object.keys(seasons)) {
      const season = seasons[Number(key)];
      if (!season) {
        continue;
      }

      const { id: seasonId, kind: seasonKind } = season;

      if (seasonKind !== selectedSeasonType) {
        continue;
      }

      const content =
        seasonId === 301 ? (
          <span>{t('Клановая квалификация')}</span>
        ) : (
          <span>
            {t('Сезон %(seasonId)s: ', {
              seasonId: seasonKind === SEASON_TYPES.REGULAR ? seasonId : seasonId - 200,
            })}
            {getLocalizationSafe(seasons[seasonId], 'title')}
          </span>
        );

      list.push({
        value: seasonId,
        content,
      });
    }

    list.sort((a, b) => {
      return b.value - a.value;
    });

    return list;
  }, [selectedSeasonType]);

  const actualSelectedSeasonId = selectedSeasonId || lastSeasonIdRef.current;

  if (!seasonsList.length || !actualSelectedSeasonId) {
    return null;
  }

  if (selectedSeasonId) {
    lastSeasonIdRef.current = selectedSeasonId;
  }

  const selectedSeason = seasonsList.find((item) => {
    return item.value === actualSelectedSeasonId;
  });

  const label = <div className={styles.label}>{selectedSeason && selectedSeason.content}</div>;

  const content =
    seasonsList.length > 1 ? (
      <Menu
        classNameMenu={styles.menu}
        items={seasonsList}
        itemSelected={actualSelectedSeasonId}
        onItemChange={onSeasonChange}
        dropdownPosition={dropdownPosition}
      >
        {label}
      </Menu>
    ) : (
      label
    );

  return <div className={styles.container}>{content}</div>;
};

export default memo(LadderSeasonsDropdown);
